@if (type === 'official-view') {
  <div class="cell official-container" [ngClass]="{'returing-side': returningSide === returningSideType}">
    @if (player.showServerNumber) {
      <div class="server-number">{{ serverNumber }}</div>
    }
    <div class="row">
      {{ player.person?.last_name }}
    </div>
    <div class="row">
      {{ player.person?.first_name }}
    </div>
  </div>
} @else {
  <div class="cell" [ngClass]="{'returing-side': returningSide === returningSideType}">
    {{ getPlayerName() }}

    @if (player?.showServerNumber) {
      <span class="server-number">{{ serverNumber }}</span>
    }
  </div>
}
